import {
  ActiveCallIcon,
  BargeTransferIcon,
  BargeTransferUnfilledIcon,
  CallIncomingIcon,
  CallOutgoingIcon,
  ContactBookIcon,
  ExtensionIcon,
  HangUpIcon,
  HangUpUnfilledIcon,
  InterceptCallIcon,
  InterceptCallUnfilledIcon,
  OnHoldIcon,
  OnHoldUnfilledIcon,
  RecordIcon,
  RecordUnfilledIcon,
  ThirdPartyIcon,
  ThirdPartyUnfilledIcon,
  ThreeDotsMenuIcon
} from '../../../../assets';
import './callItemCard.scss';
import { Typography } from '../../../common';
import { Dropdown, Space, message } from 'antd';
import type { MenuProps } from 'antd';
import React from 'react';

interface CallItemCardProps {
  name: string;
  ext: string;
  phone: string;
  duration: string;
  callDescription: React.ReactNode;
  callDirection:string;
  isRecording:boolean;
  isThirdParty: boolean;
  selectedActions: string[];
  onSelectAction: (key: string) => void;
  onHangUp: () => void;
}

const items: MenuProps['items'] = [
  {
    label: <Typography variant='body-text-2'>On Hold Call</Typography>,
    key: '1',
    icon: <img src={OnHoldUnfilledIcon} alt="" />
  },
  {
    label: <Typography variant='body-text-2'>Call Recording</Typography>,
    key: '2',
    icon: <img src={RecordUnfilledIcon} alt="" />
  },
  {
    label: <Typography variant='body-text-2'>Intercept Call</Typography>,
    key: '3',
    icon: <img src={InterceptCallUnfilledIcon} alt="" />
  },
  {
    label: <Typography variant='body-text-2'>Hang up</Typography>,
    key: '4',
    icon: <img src={HangUpUnfilledIcon} alt="" />
  },
  {
    label: <Typography variant='body-text-2'>Barge Transfer</Typography>,
    key: '5',
    icon: <img src={BargeTransferUnfilledIcon} alt="" />
  },
  {
    label: <Typography variant='body-text-2'>Third Party</Typography>,
    key: '6',
    icon: <img src={ThirdPartyUnfilledIcon} alt="" className='third-party-icon' />
  }
];

const CallItemCard = ({
  name,
  ext,
  phone,
  duration,
  callDescription,
  callDirection,
  onHangUp,
  isRecording,
  isThirdParty,
  selectedActions,
  onSelectAction,
}: CallItemCardProps) => {
  
const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
  if (key === '4') {
    onHangUp();
    return;
  }

  if (key === '6' && isThirdParty) return;
  onSelectAction(key);
};
const iconMap: { [key: string]: string } = {
  '1': OnHoldIcon,
  '2': RecordIcon,
  '3': InterceptCallIcon,
  '4': HangUpIcon,
  '5': BargeTransferIcon,
  '6': ThirdPartyIcon
};


  return (
    <div className='call-item-card-container'>
      <div className="user-icon-container">
        <img src={ActiveCallIcon} alt="user list icon" />
      </div>
      <div className="call-information-container">
        <div className="user-name-extension-container">
          <Typography variant='subHeading-1' className='user-name'>{name}</Typography>
          <div className="extension-container">
            <img src={ExtensionIcon} alt="extension icon" />
            <Typography variant='small-text-3' className='extension'>{ext}</Typography>
          </div>
        </div>
        <div className="call-status-phone-container">
          <div className="call-status-container">
            <img src={callDirection === 'inbound' ? CallIncomingIcon : CallOutgoingIcon} alt="incoming-call-icon" className='incoming-call-icon' />
            {/* status can only be answered or incoming */}
            <div className='call-description'>{callDescription}</div>
          </div>
          <div className="phone-container">
            <img src={ContactBookIcon} alt="phone book icon" />
            <Typography variant='small-text-3' className='phone'>{phone}</Typography>
          </div>
        </div>
      </div>
      <div className="time-call-options-container">
        <div className="time-duration-container">
          <Typography variant='small-heading-1'>{duration}</Typography>
        </div>
        <div className="call-options-container">
  <div className="selected-icons-container">
  {/* Render always-on icons */}
  {selectedActions.map((key) => {
    if (key === "2" && !isRecording) return null;
    if (key === "6") return null;
    return (
      <img
        key={key}
        src={iconMap[key]}
        alt={`icon-${key}`}
        className="selected-action-icon"
      />
    );
  })}

  {/* Conditionally render recording icon only if active */}
  {isRecording && (
    <img
      key="recording"
      src={RecordIcon}
      alt="record-icon"
      className="selected-action-icon"
    />
  )}

  {/* ✅ Conditionally render third party icon */}
  {isThirdParty && (
    <img
      key="third-party"
      src={ThirdPartyIcon}
      alt="third-party-icon"
      className="selected-action-icon third-party-icon"
    />
  )}
</div>

  <Dropdown menu={{ items, onClick: (info) => {
      (info.domEvent as React.MouseEvent).stopPropagation();

      handleMenuClick(info);
    } }} trigger={['click']} className='options-dropdown'>
    <a onClick={(e) => {e.preventDefault()
      e.stopPropagation()
    }}>
      <Space>
        <img src={ThreeDotsMenuIcon} alt="menu icon" />
      </Space>
    </a>
  </Dropdown>
</div>

      </div>
    </div>
  );
};

export default CallItemCard;
